import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { useApp } from "../context/AppContext";
import { pick } from "../i18n/translations";

export default function ProductCard({ product, onAdd }) {
  const { lang, fmt } = useApp();
  const price = product.sale_price || product.price;
  const old = product.sale_price ? product.price : null;
  const badges = product.badges || {};
  const oos = (product.stock ?? 100) <= 0;
  const img = (product.images || [])[0] || "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=600";

  return (
    <div className={`card-product group ${oos ? "opacity-90" : ""}`} data-testid={`product-card-${product.slug}`}>
      <Link to={`/produit/${product.slug}`} className="block relative aspect-square overflow-hidden bg-ivory-200">
        <img src={img} alt={pick(product.name, lang)} loading="lazy" decoding="async" className={`w-full h-full object-cover group-hover:scale-105 transition duration-700 ${oos ? "grayscale" : ""}`} />
        <div className="absolute top-3 start-3 flex flex-col gap-1.5">
          {oos && <span className="sticker sticker-ink bg-ink text-ivory">Rupture</span>}
          {!oos && badges.promo && <span className="sticker-coral">-30%</span>}
          {!oos && badges.new && <span className="sticker-sage">Nouveau</span>}
          {!oos && badges.top && <span className="sticker-ink">Top</span>}
          {!oos && badges.featured && <span className="sticker-ink">Recommandé orthos</span>}
        </div>
      </Link>
      <div className="p-5">
        <Link to={`/produit/${product.slug}`}>
          <h3 className="font-display text-lg leading-snug line-clamp-2">{pick(product.name, lang)}</h3>
        </Link>
        {product.approche && <p className="text-xs text-ink-soft uppercase tracking-wider mt-1" hidden>{product.approche}</p>}
        <div className="mt-3 flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={12} className="fill-coral text-coral" />
          ))}
          <span className="text-xs text-ink-soft ms-1">{product.rating || 4.9}</span>
        </div>
        <div className="mt-4 flex items-end justify-between gap-2">
          <div>
            <p className="font-display text-2xl">{fmt(price)} <span className="text-[10px] text-ink-soft font-sans align-middle">{product.is_digital ? "TTC" : "HT"}</span></p>
            {old && <p className="text-xs text-ink-soft line-through">{fmt(old)}</p>}
          </div>
          {oos ? (
            <span
              className="rounded-full bg-ink/10 text-ink-soft text-xs px-4 py-2.5 cursor-not-allowed"
              data-testid={`product-oos-${product.slug}`}
              title="Rupture de stock"
            >Indisponible</span>
          ) : (
            <button
              data-testid={`product-add-${product.slug}`}
              onClick={(e) => { e.preventDefault(); onAdd && onAdd(product); }}
              className="rounded-full bg-pedablue text-ivory text-xs px-4 py-2.5 hover:bg-pedablue-dark transition"
            >
              Ajouter
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
